import { UNSAFE_noExposureExp } from '@atlassian/jira-feature-experiments';

export function useExperimentCohort(defaultValue: string) {
	// eslint-disable-next-line jira/ff/unsafe-no-exposure
	const [expConfig] = UNSAFE_noExposureExp('jsw_presentation_toolkit_experiment');
	return expConfig.get('cohort', defaultValue);
}
